<template>

    <div class="relation612">
        <van-row>
            <van-col span="16">
                <van-row>
                    <van-col span="12">
                        <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[0])">
                            <img src="https://cdn.edstatic.com/203012120000/8c5831299798da259f682c4043d636d2/2025/09/e3b10d99-ee13-4b45-b59c-8026f4108a94.png"
                                alt="">
                        </a>
                    </van-col>
                    <van-col span="12">
                        <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[5])">
                            <img src="https://cdn.edstatic.com/203012120000/8108ea6484f0cd72d044ebecbf1e80a1/2025/09/44990048-cdc1-449c-b86c-cbec39085678.png"
                                alt="">
                        </a>
                    </van-col>
                </van-row>
                <!-- <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[0])">
                    <img src="https://cdn.edstatic.com/203012120000/a666679263842d6870895570b141af1d/2025/07/754e1411-d3e0-4adb-a217-ddd30bd4b86d.png"
                        alt="">
                </a> -->
                <van-row>

                    <van-col span="12">
                        <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[2])">
                            <img src="https://cdn.edstatic.com/203012120000/317482017c2263a9c2c0d73de201f1ae/2025/09/95e52dab-6fc5-4c54-91c3-5f2b2c85b527.png"
                                alt="">
                        </a>
                    </van-col>
                    <van-col span="12">
                        <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[3])">
                            <img src="https://cdn.edstatic.com/203012120000/0482375358d265f2769e4acfbb0d361e/2025/07/4d714a26-46c1-4a44-8e52-84359d7c9f72.png"
                                alt="">
                        </a>
                    </van-col>
                </van-row>
            </van-col>
            <van-col span="8">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[1])">
                    <img src="https://cdn.edstatic.com/203012120000/46ef556a0205e65e62228e964971c82f/2025/07/4627b44c-7ad8-43fa-ab63-1a7bf5eddbef.png"
                        alt="">
                </a>
            </van-col>
        </van-row>
        <van-row>
            <van-col span="16">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[4])">
                    <img src="https://cdn.edstatic.com/203012120000/4f5bb78af08b56219ae56913f862dda7/2025/07/401d77d4-7bac-4c34-b53a-bf09a84fce2c.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="8">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[9])">
                    <img src="https://cdn.edstatic.com/203012120000/08232e4925061474d9fe60192a984ba2/2025/09/3d636e54-6a39-45c9-b345-5f1d6d7902ef.png"
                        alt="">
                </a>
            </van-col>
        </van-row>
        <van-row>
            <van-col span="8">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[6])">
                    <img src="https://cdn.edstatic.com/203012120000/c14680a68df8a81474d324db7ac2fa91/2025/07/0501e238-b9b6-47d9-82f6-4181c14c6db9.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="8">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[7])">
                    <img src="https://cdn.edstatic.com/203012120000/5714d09dde4cdce44e552e8a2075a7f3/2025/07/a68b6973-a581-4c9d-8a45-c5e30ba8958f.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="8">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[8])">
                    <img src="https://cdn.edstatic.com/203012120000/daf4e892e26ab19305b2e84cf4a4b41e/2025/07/223f5ce2-b3d2-4236-a9b9-dc8ec212b9c9.png"
                        alt="">
                </a>
            </van-col>

        </van-row>
    </div>

</template>
<script>
export default {
    props: {
        meetingButton: Array,
        showButtonText: Number,

    },
    data() {
        return {
            button_rows: 3,
        }
    },
    methods: { // 将 skipLink 方法移至此处
        skipLink(item) {
            console.log(item);
            if (item.url.match(/\.(jpeg|jpg|gif|png)$/)) {
                ImagePreview({
                    images: [item.url],
                    closeable: true,
                    showIndex: false
                });
            } else {
                window.localStorage.removeItem('callback_url');
                window.localStorage.setItem('callback_url', item.url);
                window.location.href = item.url;

                if (item.url.indexOf('vascularnews/meeting/schedule') > -1 && window.localStorage.getItem('schedule_date')) {
                    window.localStorage.removeItem('schedule_date');
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.relation612 {
    // overflow: auto;
    padding: 0.3rem 0.5rem;
    @include flex(row);
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    background: #f9f8f8;

    .van-row {
        width: 100%;
        line-height: 0;

    }

    .van-col {
        line-height: 0;
    }

    div {
        text-align: center;
    }

    a {
        display: inline-block;
        text-align: center;
        line-height: 0;
        padding: 0.17rem;
        // margin-bottom: 16px;
    }

    img {
        width: 100%;
        height: 100%;

    }
}


.one-column {
    flex-direction: column;
    align-items: flex-start;
}



@media screen and (min-width: 500px) {
    .relation612 a {
        padding: 0.29rem !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Meeting/Button612.vue